export const fontWordSpacingTokens = () => {
  return 'unset';
};
export const fontWordSpacingTokensNova = () => {
  return 'normal';
};
//# sourceMappingURL=fontWordSpacing.js.map